import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useModalDialog from '@/composables/useModalDialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton',
  props: {
  variant: {
    type: String,
    default: 'primary',
  },
  innerWrapperClass: {
    type: String,
    default: '',
  },
  inverted: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'sm',
  },
  minWidth: {
    type: String,
    default: null,
  },
  outlined: {
    type: Boolean,
    default: true,
  },
  flat: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: null,
  },
  to: {
    type: String,
    default: null,
  },
  target: {
    type: String,
    default: null,
  },
  block: {
    type: Boolean,
    default: false,
  },
  fitHeight: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  absolute: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: String,
    default: undefined,
  },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;





const variants: Record<string, any> = {
  primary: {
    base: 'bg-button-primary border-button-primary text-global-white hover:bg-button-primary-hover hover:border-button-primary-hover hover:text-text-white active:bg-button-primary-hover active:border-button-primary-hover active:text-button-primary',
    inverted:
      'bg-global-white border-button-primary text-button-primary hover:text-global-white hover:bg-button-primary active:bg-global-surface-primary active:border-global-surface-primary active:text-global-white',
    disabled:
      'bg-button-primary-disabled border-button-primary-disabled text-text-disabled',
  },
  secondary: {
    base: 'bg-global-white border-button-secondary text-button-primary hover:bg-button-secondary-hover hover:border-button-secondary-hover active:bg-bg-button-secondary-hover active:border-button-secondary-hover',
    inverted:
      'border-global-secondary text-global-secondary hover:border-global-tertiary hover:text-global-tertiary',
    disabled:
      'bg-button-primary-disabled border-button-primary-disabled text-text-disabled',
  },
  tertiary: {
    base: 'bg-transparent border-button-primary text-button-primary hover:bg-button-tertiary-hover hover:border-button-primary active:bg-bg-button-tertiary-hover active:border-button-primary',
    inverted:
      'bg-transparent border-button-primary text-button-primary hover:bg-button-tertiary-hover hover:border-button-primary active:bg-bg-button-tertiary-hover active:border-button-primary',
    disabled: 'opacity-30 border-button-primary text-button-primary',
  },
  text: {
    base: 'text-global-primary uppercase',
    inverted: '',
    disabled: 'text-text-disabled',
  },
};

const fontSizes: Record<string, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-sm',
  lg: 'text-sm',
};

const sizes: Record<string, string> = {
  xs: 'h-8 px-4',
  sm: 'h-10 px-5',
  md: 'h-12 px-6',
  lg: 'h-16 px-6',
};

const currentVariant = computed(() => {
  let variant = props.inverted ? 'inverted' : 'base';

  if (props.disabled) {
    variant = 'disabled';
  }

  return [
    variants[props.variant][variant],
    fontSizes[props.size],
    !props.flat && sizes[props.size],
  ];
});

const clickEvent = () => {
  if (props.modal) useModalDialog(props.modal).open();
  else emit('click');
};

return { __sfc: true,props, emit, variants, fontSizes, sizes, currentVariant, clickEvent }
}

})